import type { ComponentPropsWithoutRef } from 'react'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

type Option = {
  value: string
  text: string
}

type Props = {
  name: string
  options: readonly Option[]
} & ComponentPropsWithoutRef<'select'>

export const Select = ({ name, options, ...props }: Props) => {
  return (
    <SelectWrapper name={name} {...props}>
      {options.map(({ value, text }) => (
        <option value={value} key={value}>
          {text}
        </option>
      ))}
    </SelectWrapper>
  )
}

const SelectWrapper = styled.select`
  appearance: none;
  font-size: 16px;
  line-height: 27px;
  letter-spacing: 0;
  height: 36px;
  width: 144px;
  padding-left: 18px;
  cursor: pointer;
  color: ${theme.colors.trialBlue};
  background-color: #ffffff;
  border: 1px solid ${theme.colors.trialBlue};
  border-radius: 2px;
  background-image: linear-gradient(
      to left bottom,
      ${theme.colors.trialBlue} 50%,
      transparent 50%
    ),
    linear-gradient(
      to right bottom,
      ${theme.colors.trialBlue} 50%,
      transparent 50%
    );
  background-size: 7px 10px, 7px 10px;
  background-position: calc(100% - 25px) 50%, calc(100% - 18px) 50%;
  background-repeat: no-repeat;
`
